import { Navigate, Route, Routes } from "react-router-dom";

import { AppShell } from "./components/AppShell";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Login } from "./pages/Login";
import { ChangePassword } from "./pages/ChangePassword";
import { Dashboard } from "./pages/Dashboard";
import { Orders } from "./pages/Orders";
import { Returns } from "./pages/Returns";
import { Attendance } from "./pages/Attendance";
import { Employees } from "./pages/Employees";
import { Shops } from "./pages/Shops";
import { Collection } from "./pages/Collection";
import { Catalog } from "./pages/Catalog";
import { Tasks } from "./pages/Tasks";
import { Reports } from "./pages/Reports";
import { AdminUsers } from "./pages/AdminUsers";
import { AppReleases } from "./pages/AppReleases";
import { AuditLogPage } from "./pages/AuditLog";
import { Enterprises } from "./pages/Enterprises";
import { PublicDownload } from "./pages/PublicDownload";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<PublicDownload />} />
      <Route path="/download" element={<PublicDownload />} />
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/change-password" element={<ChangePassword />} />
      </Route>
      <Route element={<ProtectedRoute allow={["admin", "superuser"]} />}>
        <Route element={<AppShell />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/attendance" element={<Attendance />} />
          <Route path="/shops" element={<Shops />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/admins" element={<AdminUsers />} />
          <Route path="/enterprises" element={<Enterprises />} />
          <Route path="/releases" element={<AppReleases />} />
          <Route path="/audit" element={<AuditLogPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
